import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormModel, FormState} from '../../../common/components/form/models';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';
import {TypeDemandes} from './type-demandes.enum';
import {MatSelectChange} from '@angular/material/select';
import {roles} from '../../../common/enum/roles';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {SafeHtmlPipe} from '@Common/widgets/pipes';
import {FormStateOptionsModel} from '../../../common/services/states/form-state-options.model';
import {DomSanitizer} from '@angular/platform-browser';
import {StatesFormService} from '../../../common/services/states/states-form.service';
import {MatCheckboxChange} from '@angular/material/checkbox';

/**
 * Comptage par formulaires des réponses selon leur état
 * librement inspiré de https://www.demarches-simplifiees.fr/procedures pour l'affichage
 */
@Component({
  selector: 'app-formulaires-demandes-liste',
  templateUrl: './formulaires-demandes-liste.component.html',
  styleUrls: ['./formulaires-demandes-liste.component.scss']
})
export class FormulairesDemandesListeComponent implements OnInit, OnDestroy {
  extraParams: Map<string, string> = new Map<string, string>();
  listForms: FormModel[] = [];
  listSelectForms: FormModel[] = [];
  stateModel: FormStateOptionsModel = this.statsFormSvc.getStateModel(FormState.published);
  listStates: FormStateOptionsModel[] = [];
  loading = false;
  typeDemandes = TypeDemandes;
  formModel: FormModel;
  subSink = new SubSink();
  isAdmin = false;
  connecte: Individu;
  connecteSearch: Individu;
  constructor(private sanitized: DomSanitizer,
              private pubSubSvc: PubSubService,
              private statsFormSvc: StatesFormService,
              private individuService: IndividuService,
              private formulaireSvc: FormulaireService) { }

  ngOnInit(): void {
    this.listStates = this.statsFormSvc.getStateModels([FormState.draft]);
    this.subSink.sink = this.individuService.individu$.subscribe(individu => {
      this.extraParams.set('state', FormState.published.toString());
      this.connecte = individu;
      this.connecteSearch = individu;
      this.isAdmin = this.individuService.hasRole(this.connecte, roles.admin);
      this.extraParams.set('by_gestionnaire', this.connecte.uid);
      this._loadFormsCount();
    });
  }
  hasForms() {
    return this.listForms && this.listForms.length > 0;
  }
  public openModalLinkForm(event, form: FormModel) {
    event.preventDefault();
    this.formulaireSvc.openModaleUrlForm(form);
  }
  displayStateForm(formulaire: FormModel) {
    if (formulaire.state) {
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
      const state: FormStateOptionsModel = this.statsFormSvc.getStateModel(formulaire.state);
      const display = `<span style="border-radius: 10px; background-color: ${state.color}; padding: 3px; color: white; font-size: 0.8em;">${state.label.toLowerCase()}</span>`;
      return sp.transform(display);
    }
    return '';
  }
  onSelectFilter(event: MatSelectChange) {
    const form = event.value as FormModel;
    if (form) {
      this.extraParams.set('uuid', form.uuid);
    } else {
      this.extraParams.delete('uuid');
    }
    this._loadFormsCount();
  }
  compareFn(state1: FormStateOptionsModel, state2: FormStateOptionsModel) {
    return state1.state === state2.state;
  }
  onSelectState(event: MatSelectChange) {
    const state = event.value as FormStateOptionsModel;
    if (state) {
      this.extraParams.set('state', state.state.toString());
    } else {
      this.extraParams.delete('state');
    }
    this._loadFormsCount();
  }
  refreshList() {
    this._loadFormsCount();
  }
  private _loadFormsCount() {
    this.loading = true;
    this.subSink.sink = this.formulaireSvc
      .getFormsResponsesCounts(this.extraParams)
      .pipe(finalize(() => this.loading = false))
      .subscribe(_data => {
        this.listForms = _data.list;
        if (this.listSelectForms.length === 0 || this.listForms.length !== this.listSelectForms.length) {
          this.listSelectForms = _data.list;
        }
      });
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  onChangeAdminView($event: MatCheckboxChange) {
    if ($event.checked) {
        this.extraParams.delete('by_gestionnaire');
        this.connecteSearch = null;
    } else {
        this.extraParams.set('by_gestionnaire', this.connecte.uid);
        this.connecteSearch = this.connecte;
    }
    this._loadFormsCount();
  }
}
